  function initBaseModal(targetModal)
  {
    if(targetModal)
    {
      jQuery(targetModal).find('.close-button').click(function(){
        closeBaseModal(targetModal);
      });
    }
  }

  function closeBaseModal(targetModal)
  {
    if(targetModal)
    {
      jQuery(targetModal).find('.base-modal, .base-modal-screen').hide();
    }
  }

  function showBaseModal(targetModal)
  {
    if(targetModal)
    {
      jQuery(targetModal).find('.base-modal, .base-modal-screen').show();
    }
  }